import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <PageLoading @message="Loading game details..." @subtitle="Getting game information, reviews, and media" />
</template>
);
